export default {
  "component.globalHeader.search": "站內搜尋",
  "component.globalHeader.search.example1": "搜尋提示一",
  "component.globalHeader.search.example2": "搜尋提示二",
  "component.globalHeader.search.example3": "搜尋提示三",
  "component.globalHeader.help": "使用說明",
  "component.globalHeader.notification": "通知",
  "component.globalHeader.notification.empty": "你已檢視所有通知",
  "component.globalHeader.message": "訊息",
  "component.globalHeader.message.empty": "您已讀完所有訊息",
  "component.globalHeader.event": "待辦",
  "component.globalHeader.event.empty": "你已完成所有待辦",
  "component.noticeIcon.clear": "清空",
  "component.noticeIcon.cleared": "清空了",
  "component.noticeIcon.empty": "暫無資料",
  "component.noticeIcon.view-more": "檢視更多",
};
